<template>
  <d2-container>
    <div class="dashboard">
      <div class="setion1">
        <div class="floatLef">
          <div class="dashboard-header">
            <div class="dashboard-title">服务导航</div>
            <div class="dashboard-title-main">
              <div class="other-box">
                <img src="./image/dashboardIcon1.png" alt="">
                <div>人工智能</div>
              </div>
              <div class="other-box">
                <img src="./image/dashboardIcon2.png" alt="">
                <div>高性能计算</div>
              </div>
              <div class="other-box">
                <img src="./image/dashboardIcon3.png" alt="">
                <div>容器服务</div>
              </div>
              <div class="other-box">
                <img src="./image/dashboardIcon4.png" alt="">
                <div>弹性计算</div>
              </div>
            </div>
          </div>
          <div class="dashboard-header">
            <div class="dashboard-title dashboard-title-two">快捷入口</div>
            <div class="dashboard-title-main">
              <div class="other-box">
                <img class="dashboardTwo" src="./image/dashboardTwo1.png" alt="">
                <div>人工智能</div>
              </div>
              <div class="other-box">
                <img class="dashboardTwo" src="./image/dashboardTwo2.png" alt="">
                <div>高性能计算</div>
              </div>
              <div class="other-box">
                <img class="dashboardTwo" src="./image/dashboardTwo3.png" alt="">
                <div>容器服务</div>
              </div>
              <div class="other-box">
                <img class="dashboardTwo" src="./image/dashboardTwo4.png" alt="">
                <div>弹性计算</div>
              </div>
            </div>
          </div>
        </div>
        <div class="floatRt">
          <div class="borderheight156">
            <img src="./image/dashboardWallet.png" class="dashboardWallet">
            <h3 class="bordercontTltle">费用概览</h3>
            <div class="borderheight156Cont ">
              <div class="fee-detail">
                <div class="itemNone"> **** </div>
                <div class="itemTxt" >账户余额</div>
              </div>
              <div class="fee-detail fee-detailRt">
                <div class="fee-detail borderline">
                  <div class="itemNone"> 0 </div>
                  <div class="itemTxt" >待支付订单</div>
                </div>
                <div class="fee-detail">
                  <div class="itemNone"> 0 </div>
                  <div class="itemTxt" >待确认订单</div>
                </div>
              </div>
            </div> 
          </div>
          <div class="overview-quick">
            <h4>运行中任务</h4>
            <div class="task-items" style="display: flex;">
              <div class="task-item">
                <div class="task-item-value">0</div>
                <div class="task-item-label">作业</div>
              </div>
              <div class="task-item">
                <div class="task-item-value">0</div>
                <div class="task-item-label">Notebook</div>
              </div>
              <div class="task-item">
                <div class="task-item-value">0</div>
                <div class="task-item-label">模型训练</div>
              </div>
              <div class="task-item">
                <div class="task-item-value">0</div>
                <div class="task-item-label">模型部署</div>
              </div>
              <div class="task-item">
                <div class="task-item-value">0</div>
                <div class="task-item-label">容器实例</div>
              </div>
            </div>
          </div>
          <div class="message-list">
            <h4>公告信息</h4>
            <div style="display: flex;justify-content: center;align-items: center;height: 91px;">
              <img style="width:80px;height:80px;margin:0 auto;" src="./image/dashmessageNone.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="setion2">
        <div class="setion2Cont">
          <h4 class="setion2Title">资源概况</h4>

          <div class="nodelist">
            <div class="nodelistCont" v-for="node in nodes" :key="node.id" @click="handleNodeSelect(node)" style="">
              <div class="item-top">
                <div class="introduce">
                  <div class="machine-type">
                    <span class="machine-alias">{{ node.alias }} / {{ node.machine }} &nbsp;&nbsp;可租用至：{{ node.rentable_until }}</span>
                    <span class="name" tabindex="0">{{ node.gpu_name }} / {{ node.gpu_memory }} GB</span>
                    <div class="gpu-num">
                      <span>空闲/总量 </span>
                      <span class="num">
                        <span class="num-bold">{{ node.free_gpus }}</span> / {{ node.total_gpus }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item-bottom">
                <div class="content">
                  <!-- CPU配置 -->
                  <div class="config-card">
                    <span class="label">每GPU分配</span>
                    <ul>
                      <li>
                        <span class="label">CPU:</span>
                        <span>
                          <span class="num-bold">{{ node.cpu_cores }}</span> 核，{{ node.cpu_model }}
                        </span>
                      </li>
                      <li>
                        <span class="label">内存:</span>
                        <span>
                          <span class="num-bold">{{ node.memory_gb }}</span> GB
                        </span>
                      </li>
                    </ul>
                  </div>
                  <!-- 硬盘配置 -->
                  <div class="config-card">
                    <span class="label">硬盘</span>
                    <ul>
                      <li>
                        <span class="label">系统盘:</span>
                        <span>{{ node.system_disk_gb }} GB</span>
                      </li>
                      <li>
                        <span class="label">数据盘:</span>
                        <span>
                          {{ node.data_disk_gb }} GB ，可扩容 {{ node.expandable_disk_gb }} GB
                        </span>
                      </li>
                    </ul>
                  </div>
                  <!-- 其他配置 -->
                  <div class="config-card">
                    <span class="label">其它</span>
                    <ul>
                      <li>
                        <span class="label">GPU驱动:</span>
                        <span>{{ node.gpu_driver_version }}</span>
                      </li>
                      <li>
                        <span class="label">CUDA版本:</span>
                        <span>
                          ≤ {{ node.cuda_version }} 
                          <span class="iconfont icon-wenhao" tabindex="0"></span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>








          
        </div>
        
      </div>

    </div>
  </d2-container>
</template>

<script>
import './style/page.css'

export default {
  name: "index-example",
  data(){
    return {
       nodes: [
        {
          id: 'node-1',
          alias: '重庆A区',
          machine: '107机',
          rentable_until: '2027-01-01',
          gpu_name: 'RTX 4090D',
          gpu_memory: 24,
          free_gpus: 1,
          total_gpus: 12,
          cpu_cores: 16,
          cpu_model: 'Xeon(R) Platinum 8474C',
          memory_gb: 80,
          system_disk_gb: 30,
          data_disk_gb: 50,
          expandable_disk_gb: 180,
          gpu_driver_version: '550.78',
          cuda_version: '12.4',
          price_per_hour: 1.98,
          original_price_per_hour: 2.08,
          discounted_price_per_hour: 1.98,
          available_gpus: 1,
        },
        // 添加更多节点...
        {
          id: 'node-3',
          alias: '重庆b区',
          machine: '10机',
          rentable_until: '2027-01-01',
          gpu_name: 'RTX',
          gpu_memory: 24,
          free_gpus: 1,
          total_gpus: 12,
          cpu_cores: 16,
          cpu_model: 'Xeon(R) Platinum 8474C',
          memory_gb: 80,
          system_disk_gb: 30,
          data_disk_gb: 50,
          expandable_disk_gb: 180,
          gpu_driver_version: '550.78',
          cuda_version: '12.4',
          price_per_hour: 1.98,
          original_price_per_hour: 2.08,
          discounted_price_per_hour: 1.98,
          available_gpus: 1,
        },
        {
          id: 'node-2',
          alias: '重庆C区',
          machine: '100机',
          rentable_until: '2027-01-01',
          gpu_name: 'RTX 4090D',
          gpu_memory: 24,
          free_gpus: 1,
          total_gpus: 12,
          cpu_cores: 16,
          cpu_model: 'Xeon(R) Platinum 8474C',
          memory_gb: 80,
          system_disk_gb: 30,
          data_disk_gb: 50,
          expandable_disk_gb: 180,
          gpu_driver_version: '550.78',
          cuda_version: '12.4',
          price_per_hour: 1.98,
          original_price_per_hour: 2.08,
          discounted_price_per_hour: 1.98,
          available_gpus: 1,
        }
      ]
    };
  },
  methods: {
  
  }
}
</script>

<style scoped>
.dashboard{
  width: 98%;
  margin: 0 1%;
  margin-top: 80px;
}
.setion1{
  overflow: hidden;
  width: 100%;
}
.floatLef{
  float: left;
  width: 70%;
  background: #F7F7F7;
  padding-bottom: 55px;
}
.floatRt{
  float: right;
  width: 29%;
  height: 200px;
}
.dashboard-header{
  width: 70%;
  padding: 0 20px 0;
}
.dashboard-title{    
  padding: 20px 0 44px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
.dashboard-title-two{
  padding-top: 50px;
}
.dashboard-title-main{
  display: flex;
}
.other-box{
  flex: 1;
  text-align: center;
  cursor: move;
  margin-right: 15px;
  border-radius: 5px;
  cursor: pointer;
}
.other-box img{
  width: 150px;
  height: 80px;
  margin-bottom: 5px;
}
.other-box  img.dashboardTwo{
  width: 72px;
  height: 73px;
  margin-bottom: 25px;
}
.other-box div{
  font-size: 14px;
  line-height: 14px;
}

.borderheight156{
  height: 156px;
  padding: 0 20px;
  background-image: linear-gradient(180deg, #DBECFF 0%, #FFFFFF 100%);
  border-radius: 4px;
  position: relative;
}
h3.bordercontTltle{
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  padding: 20px 0 12px;
  margin: 0;
}

.dashboardWallet{
  position: absolute;
  width: 78px;
  height: 76px;
  right:2px;
  z-index: 1;
}
.borderheight156Cont{
  position: relative;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  z-index: 5;
  padding: 14px 20px;
  overflow: hidden;
}
.fee-detail{
  float: left;
}
.fee-detail .itemNone{
  font-size: 24px;
  color: #4173FF;
  font-weight: 500;
  margin-bottom: 7px;
  line-height: 24px;
  text-align: center;
}
.fee-detail .itemTxt{
  font-size: 12px;
  color: #555555;
  font-weight: 400;
}
.fee-detailRt{
  float: right;
}
.borderline{
  border-right: 1px solid #a29f9f;
  margin: 0 20px;
  padding-right: 20px;
}

.overview-quick{
  background: #F5F5F5;
  padding: 0 20px 20px;
  margin-top: 12px;
}
.overview-quick h4{
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  padding: 20px 0;
  margin: 0;
}
.task-items{
  display: flex;
}
.task-item{
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  cursor: move;
  margin-right: 15px;
  border-right: 1px solid #a29f9f;
}
.task-item:last-child{
  border-right:0;
}
.task-item-value{
  font-size: 24px;
  color: #555555;
  font-weight: 400;
  padding-bottom: 5px;
}
.task-item-label{
  font-size: 12px;
  color: #999999;
  text-align: center;
  font-weight: 400;
}

.message-list{
  background: #F5F5F5;
  padding: 0 20px 20px;
  margin-top: 12px;
}
.message-list h4{
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  padding: 20px 0;
  margin: 0;
}
.setion2{
  width: 100%;
  background:#F5F5F5;
  margin-top: 10px;
}
.setion2Cont{
  padding: 20px;
}
.setion2Title{
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  margin: 0;
  padding-bottom: 20px;
}
</style>
